import { SubAPI } from "./SubAPI";
export class PDFTable extends SubAPI {
    constructor() { super(...arguments); this.tableClassName = "pdf-table-rendered"; this.pageClassName = "pdf-table-page"; this.defaultStyle = { visibility: "hidden", height: 10 }; }
    encodeContent(param) { return JSON.stringify(param); }
}
